export default __webpack_public_path__ + "static/media/doctor-examining-senior-patient-blood-sugar.1579bee8.jpg";